export const FETCH_BRANCH_LIST_REQUEST = 'FETCH_BRANCH_LIST_REQUEST';
export const FETCH_BRANCH_LIST_SUCCESS = 'FETCH_BRANCH_LIST_SUCCESS';
export const FETCH_BRANCH_LIST_FAILURE = 'FETCH_BRANCH_LIST_FAILURE';
export const CLEAR_BRANCH_LIST = 'CLEAR_BRANCH_LIST';
